<template>
  <div style="text-align:left">
    <Breadcrumb style="margin: 0px 10px 20px">
        <BreadcrumbItem>广告管理</BreadcrumbItem>
    </Breadcrumb>
    <Card>
		<Form ref="form" :model="formItem" :label-width="100">
			<Row>
                <Col span="6">
                    <FormItem label="广告ID">
                        <Input v-model="formItem.ad_id"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="广告名称">
                        <Input v-model="formItem.title"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="广告类型">
                        <Select v-model="formItem.ad_content_type" clearable placeholder="请选择广告类型">
                            <Option value="1">营收业务</Option>
                            <Option value="2">主推活动</Option>
                            <Option value="3">常规活动</Option>
                            <Option value="4">会员宣导</Option>
                            <Option value="5">用户运营</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <Button @click="getAdList(1,20,formItem.title,formItem.ad_id,formItem.ad_content_type)" style="margin-left:20px" type="primary">搜索</Button>
                </Col>
            </Row>
		</Form>
        <Button @click="handleCreate" style="margin:0px 10px 20px" type="primary">新建广告</Button>
        <Table :columns="columns" :data="data"></Table>
        <Page show-total :current="page" @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
	</Card>
    
  </div>
</template>
<script>
import{adList,deleteTemplate,planListByAd,stopPlans}from "@/request/api"
import Cookies from 'js-cookie';
export default {
    name: 'adAdmin',
    meta:{
        keepAlive: true // 开启缓存
    },
    data() {
        return {
            formItem:{
                title: '',
                ad_id: '',
                ad_content_type: ''
            },
            columns: [
                {
                    title: "广告id",
                    key: "ad_id",
                    align: 'center'
                },
                {
                    title: "广告名称",
                    key: "title",
                    align: 'center'
                },
                {
                title: '广告图片',
                key: 'material_url',
                align: 'center',
                render: (h, params) => {
                        return (
                            <img
                                src={params.row.material_url}
                                style={{ width: '100px', height: 'auto', margin: '0 auto', display:params.row.material_url?'':'none' }}
                                alt="Image"
                            />
                        );
                    }
                },
                {
                    title: "广告样式",
                    key: "template_name",
                    align: 'center'
                },
                {
                    title: "创建者",
                    key: "user_name",
                    align: 'center'
                },
                {
                    title: "创建日期",
                    key: "created_at",
                    align: 'center'
                },
                {
                    title: "更新日期",
                    key: "updated_at",
                    align: 'center'
                },
                {
                    title: "操作",
                    key: "action",
                    align: 'center',
                    render: (h, params) => {
                        return h("div", [
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.handleSearchPlans(params.row.ad_id)
                                },
                            },
                            },"当前投放计划"),
                        h("Button", {
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.$router.push({
                                        name: "editAd",
                                        query: {
                                            ad_id: params.row.ad_id,
                                        },
                                    });
                                },
                            },
                            },"编辑"),
                        h("Button",{
                            props: {
                                type: "text",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.$Modal.confirm({
                                        title: "提示",
                                        content: "是否删除该项？",
                                        onOk: () => {
                                            this.handleDelete(1,20,params.row.ad_id)
                                        },
                                    });
                                },
                            },
                            },"删除")
                        ]);
                    },
                },
            ],
            data: [],
            total_count:0,
            page:1,
            plans_total: 0,
            plans_data: [
            ],
            plans_columns: [
                { title: 'ID', key: 'plan_id', align: 'center' },
                { title: '投放时间', key: 'plan_period', align: 'center' },
                { title: '投放计划名称', key: 'plan_name', align: 'center' },
                { title: '执行状态', key: 'status', align: 'center' },
                { title: '投放方式', key: 'plan_type', align: 'center', render: (h, { row } ) => {
                        if (row.plan_type === 1) {
                            return h('span', {
                            }, '按投放天数');
                        } else if (row.plan_type === 2) {
                            return h('span', {
                            }, '按曝光次数');
                        }else if (row.plan_type === 3) {
                            return h('span', {
                            }, '按点击次数');
                        }
                    }, 
                },
                { title: '投放目标', key: 'target_number', align: 'center',render: (h, { row } ) => {
                        if (row.plan_type === 1) {
                            return h('span', {
                            }, row.target_number+'天');
                        } else {
                            return h('span', {
                            }, row.target_number+'次');
                        }
                    },
                },
                { title: '版位名称', key: 'placement_name', align: 'center' },
                { title: '创建者', key: 'user_name', align: 'center' },
                { title: '创建时间', key: 'created_at', align: 'center' }
            ],
        };
    },
    methods: {
        getAdList(page=1,page_size=20,title,ad_id,ad_content_type){
            adList({page,page_size,title,ad_id,ad_content_type}).then(res=>{
                if(res.data.code==200){
                    this.data=res.data.data.advertisements
                    this.total_count=res.data.data.total
                    this.page = page
                }
            })
        },
        changePage(page){
            this.getAdList(page,20,this.formItem.title,this.formItem.ad_id,this.formItem.ad_content_type)
            this.page=page
        },
        handleCreate(){
            this.$router.push({
                name: "createAd",
            });
        },

        // 删除广告
        handleDelete(page,page_size,ad_id){
            planListByAd({page,page_size,ad_id}).then(res=>{
                if(res.data.code==200){
                    this.plans_data=res.data.data.plans
                    this.plans_total=res.data.data.total
                    if (this.plans_total==0) {
                        deleteTemplate({ad_id:ad_id}).then(res=>{
                            if(res.data.code==200){
                                this.$Message.success('删除成功');
                                this.getAdList(this.page,20,this.formItem.title,this.formItem.ad_id,this.formItem.ad_content_type)
                            }else{
                                this.$Message.error(res.data.msg);
                            }
                        })
                    } else {
                        this.$Message.error('删除失败，当前存在投放计划');
                    }
                    this.plans_data = []
                    this.plans_total = 0
                }else{
                    this.$Message.error(res.data.msg);
                }
            })
        },
        getPlansList(page=1,page_size=20,ad_id){
            planListByAd({page,page_size,ad_id}).then(res=>{
                if(res.data.code==200){
                    this.plans_data=res.data.data.plans
                    this.plans_total=res.data.data.total
                }
            })
        },
        handleStopPlans(){
            let plans_ids = []
            this.plans_data.forEach((item, index) => {
                plans_ids.push(item.plan_id)
            })
            stopPlans({
                plan_ids: plans_ids.join(',')
            }).then(res=>{
                if(res.data.code==200){
                    this.$Message.success('Success');
                }else{
                    this.$Message.error(res.data.msg);
                }
                this.plans_data = []
                this.plans_total = 0
            })
        },
        handleSearchPlans(ad_id){
            this.getPlansList(1, 20, ad_id)
            this.$Modal.confirm({
                title: "当前投放计划",
                okText: "批量删除",
                cancelText: "关闭",
                width:'70%',
                render: (h) => {
                    return h('Table', {
                        props: {
                            columns: this.plans_columns,
                            data: this.plans_data,
                            rowKey: 'plan_id'
                        }
                    });
                },
                onOk: () => {
                    this.handleStopPlans()
                },
                onCancel: () => {
                    this.plans_data = []
                    this.plans_total = 0
                }
            });
        }
    },
    created() {
        Cookies.set('active_name', '2');
        this.getAdList(1,20)
    },
    activated() {
        // 在这里刷新列表
        this.getAdList(this.page,20,this.formItem.title,this.formItem.ad_id,this.formItem.ad_content_type)
    },
};
</script>


// WEBPACK FOOTER //
// src/views/Ad/AdHome.vue